import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaSync } from "react-icons/fa";

export default function LoopNode({ data, selected }) {
  const messagePreview = data.message
    ? data.message.length > 40
      ? data.message.slice(0, 40) + "…"
      : data.message
    : null;

  const recipientsLabel =
    data.recipients?.length > 0
      ? `${data.recipients.length} recipients`
      : "Trigger contact";

  const intervalLabel =
    data.intervalType === "cron"
      ? data.cronExpression || "—"
      : data.intervalValue && data.intervalUnit
      ? `Every ${data.intervalValue} ${data.intervalUnit}`
      : null;

  const repeatLabel =
    data.repeatCount > 0 ? `×${data.repeatCount}` : "∞";

  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[180px] transition-shadow ${
        selected ? "border-teal-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-teal-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-teal-500">
        <FaSync size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Loop</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {messagePreview ? (
          <p className="text-xs text-ink-primary">{messagePreview}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure</p>
        )}

        <p className="text-xs text-ink-muted mt-1">{recipientsLabel}</p>

        {intervalLabel && (
          <p className="text-xs text-ink-muted mt-1">
            {intervalLabel}{" "}
            <span className="font-semibold">{repeatLabel}</span>
          </p>
        )}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-teal-500 !border-2 !border-white"
      />
    </div>
  );
}
